import { useSelector, useDispatch } from "react-redux";
import React from "react";
import { TextField, Typography, InputAdornment } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import { blue } from "@mui/material/colors";
import { useForm } from "hooks/useForm";
import { addComment } from "redux/actions/orders/ordersActions";
import SendIcon from "@mui/icons-material/Send";

export const OrderComments = ({ order }) => {
  const { isLoadingComp } = useSelector(({ search }) => search);

  const dispatch = useDispatch();
  const {
    inputValues,
    handleInputOnChange,
    cleanForm,
    runValidates,
    fieldErrors,
  } = useForm(
    {
      comment: "",
    },
    { comment: { required: true } }
  );
  const { comment } = inputValues;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (runValidates()) return;
    dispatch(addComment(order.id, { comment }, cleanForm));
  };
  return (
    <>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          leftPadding: 24,
          marginTop: 16,
        }}
      >
        <TextField
          variant="outlined"
          label="Agregar comentario"
          name="comment"
          value={comment}
          onChange={handleInputOnChange}
          error={!!fieldErrors.comment}
          fullWidth
          multiline
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RegularButton justIcon round color="transparent" onClick={handleSubmit} loading={isLoadingComp?.loadingAddComment}>
                  <SendIcon style={{ color: blue[500] }} />
                </RegularButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
      <div
        style={{
          marginTop: 32,
          maxHeight: '64vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {order?.annotations
          ? order.annotations.map((comment, index) => (
            <div
              key={comment.id ?? index}
              style={{
                padding: 12,
                borderRadius: 12,
                borderTopLeftRadius: 0,
                position: "relative",
                backgroundColor: blue[100],
                marginBottom: 40,
              }}
            >
              <Typography
                variant="caption"
                style={{
                  position: "absolute",
                  right: 5,
                  top: -16,
                  color: blue[300],
                }}
              >
                {comment.name}
              </Typography>
              <Typography
                variant="body1"
                style={{
                  marginRight: 4,
                  textAlign: "end",
                }}
              >
                {comment.comment}
              </Typography>
              <Typography
                variant="caption"
                style={{
                  position: "absolute",
                  left: 5,
                  bottom: -20,
                  color: blue[300],
                }}
              >
                {comment.created}
              </Typography>
            </div>
          ))
          : null}
      </div>
    </>
  );
};
